<template>
    <div>
        <v-server-table ref="fieldTrainingTable" url="/subcontractors/field-training-list" :columns="columns" :options="options">

            <template slot="field_training_id" slot-scope="props">
                <router-link :to="`/subcontractors/settings/field-trainings/edit/${props.row.field_training_id}`" title="Edit Field Training">
                    Edit
                </router-link>
                |
                <a class="text-danger" href="javascript:void(0);" @click="deleteTraining(props.row.field_training_id)" title="Delete Field Training">
                    Delete
                </a>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['field_training_id', 'field_training_name'],
                options: {
                    columnsDropdown: false,
                    headings: {
                        field_training_id: 'Actions',
                        field_training_name: 'Field Training Name',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'field_trainings.field_training_name',
                    },
                    uniqueKey: 'field_training_id',
                },
            }
        },
        methods: {
            deleteTraining: function(field_training_id) {
                if (confirm('Are you sure you want to delete this field training? It will be removed from all subcontractors that are using it.'))
                {
                    this.$http
                        .post(`subcontractors/field-training-delete/${field_training_id}`)
                        .then(response => {
                            this.$toastr.success('Field Training Deleted');

                            this.$refs.fieldTrainingTable.refresh();
                        })
                        .catch(response => {

                        });
                }
            }
        },
    }
</script>
